<template>
  <view wx:class="{{ {'es-card':true, margin:margin} }}">
    <block wx:if="{{!hideTitle}}">
      <view bindtap="onSideClick" class="es-card__title">
        <slot name="title">
          <view class="es-card__title-text">{{title}}</view>
        </slot>
        <view class="es-card__title-side">
          <slot name="titleSide">
            <view
              class="es-card__title-side-text"
              style="{{ {color: sideColor || '#666666'} }}"
            >{{sideTitle}}</view>
            <es-icon
              wx:if="{{sideIcon}}"
              name="angle-right"
              size="{{ !sideTitle ? 20 : 16 }}"
              color="{{ sideColor || '#666666' }}"
            />
          </slot>
        </view>
      </view>
      <view wx:if="{{!hideDivider}}" class="es-card__divider"></view>
    </block>
    <view><slot /></view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      },
      sideTitle: {
        type: String,
        value: ''
      },
      sideIcon: {
        type: Boolean,
        value: false
      },
      sideColor: {
        type: String,
        value: ''
      },
      margin: {
        type: Boolean,
        value: true
      },
      hideTitle: {
        type: Boolean,
        value: false
      },
      hideDivider: {
        type: Boolean,
        value: false
      },
    },
    methods: {
      onSideClick() {
        this.$trigger('sideClick', null)
      }
    }
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
</script>